<template>
  <!--  专题新闻-->
  <div class="thematic-news">
    <img src="https://img.qiluyidian.net/shareimg20191216.jpg" alt="" style="z-index: -10;position: absolute">
    <div class="tips clearfix" ref="tips">
      <span class="homeIcon" :style="{backgroundImage:home_url,backgroundSize:'100%'}" @click="goHome"></span>
      <i class="rightLine"></i>
      <span class="slogon">齐鲁晚报官方APP</span>
      <span class="openApp" @click="down">打开</span>
    </div>
    <div class="loading" :style="{backgroundImage:loading_url,backgroundSize:'20%'}" v-if="loading==0"></div>
    <div class="loading" :style="{backgroundImage:error1_url,backgroundSize:'50%'}" v-else-if="loading==1"></div>
    <div class="loading" :style="{backgroundImage:deleted_url,backgroundSize:'50%'}" v-else-if="loading==2"></div>
    <!--   图片 简介 标签-->
    <div class="thematicInfo clearfix">
      <img v-if="thematicInfo.headimg" class="themePic" :src="thematicInfo.headimg" alt="">
      <img v-else class="themePic" src="../../common/img/defaultPicture.png" alt="">
      <div class="thematicIntro">
        <!--        <p class="stratIntro"></p>-->
        <div class="intro clearfix">
          <span class="stratIntro">
            <i class="icon" :style="{backgroundImage:thematic_url,backgroundSize:'contain'}"></i>
            <i class="line"></i>
          </span>
          <p>{{thematicInfo.content}}</p>
        </div>
        <div class="themViewCount" v-if="thematicInfo.view_count">专题阅读量{{thematicInfo.view_count}}</div>
        <div class="tags clearfix">
          <span class="tagBorder" v-for="(item,index) in thematicInfo.labelList">
            <span class="tagBg" @click="tagJump(index)">{{item}}</span>
          </span>
        </div>
      </div>
    </div>
    <!--    新闻列表-->
    <div class="list" v-for="lists in thematicInfo.subjectItemNewsList">
      <div class="listWrapper">
        <p class="listName" v-if="lists.label"><span>{{lists.label}}</span></p>
        <div class="newType" v-for="(item,index) in lists.subjectNewsList">
          <!--        广告  isAd  1-->
          <div class="newListAdv" @click="goMost(item.type,item.sourceId,item.detailurl,item.status)"
               v-if="item.isAd == '1'">
            <p class="advTitle">{{item.conenttitle}}</p>
            <img v-if="item.conentimg1" class="advImg" :src="item.conentimg1 + param" alt="">
            <img v-else class="advImg" src="../../common/img/defaultPicture.png" alt="">
            <p class="advText adColor1 clearfix">广告</p>
          </div>
          <!--      普通新闻-->
          <div class="newList clearfix" @click="goGeneral(item.conentid)" v-else-if="item.conenttype == '1' || item.conenttype == '20'">
            <img v-if="item.conentimg1" class="newImg" :src="item.conentimg1 + param" alt="">
            <img v-else class="newImg" src="../../common/img/defaultPicture.png" alt="">
            <img v-if="item.conenttype == '20'" class="ypTips" src="../../common/img/ypTips.png" alt="">
            <div class="newsRight">
              <p class="newsTitle">{{item.conenttitle}}</p>
              <p class="timeView">
<!--                <span class="source read" v-if="item.channel_name">{{item.channel_name}}</span>-->
<!--                <span class="source" v-else>{{item.source}}</span>-->
                <span class="source">{{item.timestr}}</span>
                <span class="yue" v-if="item.viewcount != 0&& item.viewcount != '' && item.viewcount>=1000 || item.viewcount.indexOf('万')!='-1'">{{item.viewcount}}阅</span>
                <span class="ping" v-if="item.commentcount != 0&& item.commentcount != ''&&item.viewcount<1000 && item.viewcount.indexOf('万')=='-1'">{{item.commentcount}}评</span>
              </p>
            </div>
          </div>
          <!--      广告（取消）  活动6  直播10（预告  回顾 未定） 商品5  图文直播8-->
          <div class="newListAdv" @click="goLive(item.conentid)"
               v-else-if="item.conenttype == '10'">
            <p class="advTitle">{{item.conenttitle}}</p>
            <img v-if="item.conentimg1" class="advImg" :src="item.conentimg1 + param" alt="">
            <img v-else class="advImg" src="../../common/img/defaultPicture.png" alt="">
            <!--          <p class="advText adColor0">广告</p>-->
            <p class="advText adColor1" v-if="item.conenttype == '6'">活动</p>
            <p class="advText adColor1" v-else-if="item.conenttype == '5'">商品</p>
            <p class="advText adColor1" v-else-if="item.conenttype == '8'">图文直播</p>
            <p class="advText adColor1" v-else-if="item.conenttype == '10' && item.status == '2'">预告</p>
            <p class="advText adColor2" v-else-if="item.conenttype == '10' && item.status == '1'">直播</p>
            <p class="advText adColor0" v-else>回顾</p>
          </div>
          <div class="newListAdv" @click="goMost(item.type,item.sourceId,item.detailurl,item.status)"
               v-else-if="item.conenttype == '6' || item.conenttype == '5' || item.conenttype == '8'">
            <p class="advTitle">{{item.conenttitle}}</p>
            <img v-if="item.conentimg1" class="advImg" :src="item.conentimg1 + param" alt="">
            <img v-else class="advImg" src="../../common/img/defaultPicture.png" alt="">
            <!--          <p class="advText adColor0">广告</p>-->
            <p class="advText adColor1" v-if="item.conenttype == '6'">活动</p>
            <p class="advText adColor1" v-else-if="item.conenttype == '5'">商品</p>
            <p class="advText adColor1" v-else-if="item.conenttype == '8'">图文直播</p>
            <p class="advText adColor1" v-else-if="item.conenttype == '10' && item.status == '2'">预告</p>
            <p class="advText adColor2" v-else-if="item.conenttype == '10' && item.status == '1'">直播</p>
            <p class="advText adColor0" v-else>回顾</p>
          </div>
          <!--      视频-->
          <div class="newListVideo" @click="goVideo(item.conentid)" v-else-if="item.conenttype == '3'">
            <p class="videoTitle">{{item.conenttitle}}</p>
            <div class="videoWraper">
              <img v-if="item.conentimg1" class="videoImg" :src="item.conentimg1 + param" alt="">
              <img v-else class="videoImg" src="../../common/img/defaultPicture.png" alt="">
              <span class="stop" :style="{backgroundImage:stop_url,backgroundSize:'13%'}"></span>
              <!--              <span class="time">00:00</span>-->
            </div>
            <p class="videoDetail">
              <span class="videoText" v-if="item.columnName">{{item.columnName}}</span>
              <span class="videoText" v-else-if="item.ownername">{{item.ownername}}</span>
              <span class="videoText" v-else="item.source">{{item.source}}</span>
              <span>{{item.timestr}}</span>
            </p>
          </div>
          <!--      图集新闻-->
          <div class="newListPic" @click="goAtlas(item.conentid)" v-else-if="item.conenttype == '2'">
            <p class="picTitle">{{item.conenttitle}}</p>
            <div class="picWraper">
              <img class="picImg" v-if="item.conentimg1" :src="item.conentimg1 + param" alt="">
              <img class="picImg" v-else="!item.conentimg1" src="../../common/img/defaultPicture.png" alt="">
              <img class="picImg" v-if="item.conentimg2" :src="item.conentimg2 + param" alt="">
              <img class="picImg" v-else="!item.conentimg2" src="../../common/img/defaultPicture.png" alt="">
              <img class="picImg" v-if="item.conentimg3" :src="item.conentimg3 + param" alt="">
              <img class="picImg" v-else="!item.conentimg3" src="../../common/img/defaultPicture.png" alt="">
            </div>
          </div>
          <!--              专题新闻-->
          <div class="thematicPic" ref="thematicPic" @click="goThematic(item.conentid)" v-else-if="item.conenttype == '4'">
            <p class="picTitle">{{item.conenttitle}}</p>
            <div class="picWraper0">
              <div class="picWraper">
                <img class="picImg" v-for="itm in item.subjectNewsList" v-if="itm.conentimg1" :src="itm.conentimg1 + param" alt="">
                <img class="picImg" v-else src="../../common/img/defaultPicture.png" alt="">
              </div>
            </div>
          </div>
          <i class="line" v-if="index < lists.subjectNewsList.length-1"></i>
        </div>
      </div>
    </div>
    <div class="toTop" v-if="topShow">
<!--      <span class="top" :style="{backgroundImage:top_url,backgroundSize:'contain'}" @click.stop="toTop"></span>-->
      <span class="index" :style="{backgroundImage:index_url,backgroundSize:'contain'}" @click.stop="goHome"></span>
    </div>
    <div class="blockWhite">加载完毕</div>
  </div>
</template>

<script>
  import '../../common/css/reset1.css'
  import {getUrlParam,scriptFun,configData} from "../../common/js/common";
  import {thematicDetails,getActUrl} from "../../common/api/api";
  import {getWeixinAuth} from "../../common/js/weixinshare";
  import {isWeixin} from "../../common/js/authorize";
  export default {
    name: 'thematic-news',
    components: {},
    data() {
      return {
          param:'?imageView2/2/w/720/q/85|imageslim',
        home_url: "url(" + require('../../common/img/home.png') + ")",
        thematic_url: "url(" + require('../../common/img/thematic.png') + ")",
        loading_url: "url(" + require('../../common/img/loading.gif') + ")",
        error_url: "url(" + require('../../common/img/newsError.png') + ")",
        error1_url: "url(" + require('../../common/img/newsError1.png') + ")",
          deleted_url: "url(" + require('../../common/img/newsDelete.png') + ")",
        stop_url: "url(" + require('../../common/img/video-stop.png') + ")",
          top_url: "url(" + require('../../common/img/comment.png') + ")",
          index_url: "url(" + require('../../common/img/index.png') + ")",
        thematicInfo: [],
        newsId: '',
        routeId: '',
        loading:0,
        arrayH:[],
          topShow:false,
      }
    },
    watch: {},
    mounted() {
      this.$nextTick(function () {
        // scriptFun();
        if(!isWeixin()){
          this.$refs.tips.style.display = 'none';
        }
      //   getWeixinAuth();
      })
    },
    created() {
      this.routeId = getUrlParam('id')
      this.fetchDetails();
      window.addEventListener('scroll',()=>{
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动条距离顶部高度
          let seeHeight = document.documentElement.clientHeight; //可见区域高度
          // 滚动两屏以上时显示返回顶部按钮
          let twoClient = seeHeight * 2;
          // if (scrollTop >= twoClient) {
          //     this.topShow = true;
          // }else {
          //     this.topShow = false;
          // }
        if(isWeixin()) {
          let tips = document.getElementsByClassName('tips');
          this.arrayH.unshift(scrollTop);
          this.arrayH.length = 2;
          if (this.arrayH[0] > this.arrayH[1]) {//上滑
            if (scrollTop<=0){
              tips[0].style.display = 'block'
            }else {
              tips[0].style.display = 'none'
            }
          } else if (this.arrayH[0] < this.arrayH[1] || scrollTop <= 0) {//下滑
            tips[0].style.display = 'block'
          }
        }
      })
    },
    methods: {
      // 情报详情
      fetchDetails() {
        let params = {
          "newsid": this.routeId,//13,
        };
        thematicDetails(params).then(res => {
          if (res.data.rc == 0) {
            this.loading = -1;
              this.topShow = true;
            this.thematicInfo = res.data.data;
            document.title= this.thematicInfo.title;
            getWeixinAuth();
            this.$nextTick(function () {
              if(!isWeixin()){
                document.getElementsByClassName('thematic-news')[0].style.paddingTop = 0;
              }
            })
          }else if (res.data.rc == '301') {
              this.loading = 2;
          }  else {
            this.loading = 1;
          }
        })
      },
      tagJump(index){
        this.$nextTick(function () {
          let listArr = document.getElementsByClassName('list');
          let offTop = '';
          if(this.thematicInfo.labelList.length == listArr.length-1 ){
            offTop = listArr[index+1].offsetTop;
          }else {
            offTop = listArr[index].offsetTop;
          }
          document.documentElement.scrollTop = offTop;
          document.body.scrollTop = offTop;
        })
      },
      goGeneral(id) {
          if(getUrlParam('mwb')){
              location.href = configData.jumpUrl+'/general.html?id=' + id + '&mwb=' + 'mobi';
          }else {
              location.href = configData.jumpUrl+'/general.html?id=' + id;
          }
      },
      goAtlas(id) {
          if(getUrlParam('mwb')){
              location.href = configData.jumpUrl+'/atlas.html?id=' + id + '&mwb=' + 'mobi';
          }else {
              location.href = configData.jumpUrl+'/atlas.html?id=' + id;
          }
      },
        goMost(type, id, url, status) {
            //活动 this.infoDetails.adinfo.type == '6'
            if (type == 6) {
                let params = {
                    "active_id": id,
                };
                getActUrl(params).then(res => {
                    if (res.data.rc == 0) {
                        if (!res.data.data.small_id) {
                            window.location.href = res.data.data.html_id;
                        }
                    } else {
                    }
                })
            }else if(type == 18){//情报 this.infoDetails.adinfo.type == '18'
                if (getUrlParam('mwb')) {
                    location.href = configData.jumpUrl + '/info.html?id=' + id + '&mwb=' + 'mobi';
                } else {
                    location.href = configData.jumpUrl + '/info.html?id=' + id;
                }
            }else if (type == 12) {//外链
                window.location.href = url;
            } else if (type == 1 || type == 20) {
                this.goGeneral(id);
            } else if (type == 4) {
                this.goThematic(id);
            } else if (type == 2) {
                this.goAtlas(id);
            } else if (type == 10) {
                if (getUrlParam('mwb')) {
                    location.href = configData.jumpUrl + '/live.html?id=' + id + '&mwb=' + 'mobi';
                } else {
                    location.href = configData.jumpUrl + '/live.html?id=' + id;
                }
            } else if (type == 3) {
                this.goVideo(id);
            }
        },
        goLive(id){
            if (getUrlParam('mwb')) {
                location.href = configData.jumpUrl + '/live.html?id=' + id + '&mwb=' + 'mobi';
            } else {
                location.href = configData.jumpUrl + '/live.html?id=' + id;
            }
        },
      goVideo(id) {
          if(getUrlParam('mwb')){
              location.href = configData.jumpUrl+'/video.html?id=' + id + '&mwb=' + 'mobi';
          }else {
              location.href = configData.jumpUrl+'/video.html?id=' + id;
          }
      },
      goThematic(id) {
          if(getUrlParam('mwb')){
              location.href = configData.jumpUrl+'/thematic.html?id=' + id + '&mwb=' + 'mobi';
          }else {
              location.href = configData.jumpUrl+'/thematic.html?id=' + id;
          }
      },
      down() {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.qlwb.qiluyidian'
        } else if (isiOS) {
          window.location.href = 'https://itunes.apple.com/cn/app/qi-lu-yi-dian-ti-yu-gong-jiao/id903816468?mt=8'
        }
      },
      goHome() {
          if(getUrlParam('mwb')){
              location.href = configData.jumpUrl + '/mobiIndex.html';
          }else {
              location.href = configData.jumpUrl + '/index.html';
          }
      },
        toTop(){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../common/css/base.scss";
  @import "css/thematic";
</style>



// WEBPACK FOOTER //
// App.vue?248ada0a